class RouteParams{
    constructor(json){
        this.entity = json.entity;
        this.itemId = json.itemId;
        this.docClass = json.docClass;            
    }
}

export default RouteParams